import React from 'react';
import PropTypes from 'prop-types';

const Pin = ({ fill, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.8"
    height="15.8"
    viewBox="0 0 12.8 15.8"
    className={className}
  >
    <g>
      <path
        d="M6.4,0C2.9,0,0,2.9,0,6.4c0,3.3,4.8,9.4,6.4,9.4c1.5,0,6.4-6.1,6.4-9.4C12.8,2.9,9.9,0,6.4,0z M6.4,13.9 C5.2,13,1.8,8.7,1.8,6.4c0-2.6,2.1-4.6,4.6-4.6c2.5,0,4.6,2.1,4.6,4.6C11,8.7,7.5,13,6.4,13.9z"
        fill={fill}
      />
      <path
        d="M6.4,3.1c-1.8,0-3.2,1.4-3.2,3.2s1.4,3.2,3.2,3.2c1.8,0,3.2-1.4,3.2-3.2S8.1,3.1,6.4,3.1z M6.4,7.8 c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5S7.2,7.8,6.4,7.8z"
        fill={fill}
      />
    </g>
  </svg>
);

Pin.propTypes = {
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Pin;
